import React from 'react'
import { LangSelectButton } from '../styles/inputs'

type Props = {
    imgUrl: string;
    onClick: () => void;
    title?: string;
    size?: 'small' | 'medium';
}

const LangSelectorButton = ({ imgUrl, onClick, title, size = "medium" }: Props) => {
    return (
        <LangSelectButton
            onClick={onClick}
            title={title}
        >
            <img
                src={imgUrl}
                alt={title}
                style={{
                    width: size === 'small' ? '20px' : '40px',
                    height: size === 'small' ? '20px' : '40px',
                    marginBottom: "-5px"
                }}
            />
        </LangSelectButton>
    )
}

export default LangSelectorButton